import { addConsultAnswer, removeConsultAnswer } from "../actions";
import { baseUrl } from "./config";

/* export const createConsult = async payload => {
  return database
    .collection(collection)
    .add(payload)
    .then(result => {
      //console.log(result);
      return { error: false };
    })
    .catch(error => {
      console.log("error ", error);
      return { error: true };
    });
}; */

export const getHistory = async (userId, token, page) => {
  try {
    const result = await fetch(
      `${baseUrl}/consults/user/${userId}?page=${page}`,
      {
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!result.ok) {
      return { error: true };
    }

    const data = await result.json();
    return data;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};
